// Polyfills for Node.js environment
// Only import polyfills in browser environment, not in test environment
if (typeof window !== 'undefined') {
  try {
    const { Buffer } = require('buffer');
    const process = require('process/browser');

    // Set up global polyfills
    global.Buffer = Buffer;
    global.process = process;

    // Ensure process.env is available
    if (!global.process.env) {
      global.process.env = {};
    }

    // Add NODE_ENV if not present
    if (!global.process.env.NODE_ENV) {
      global.process.env.NODE_ENV = process.env.NODE_ENV || 'development';
    }
  } catch (error) {
    // Polyfills not available
  }
}
